import React from 'react';
import ResampleDialog, { ResampleFormData } from '@Components/ResampleDialog';
import { ResampleJobFnRequest, useResampleJobs } from '@Hooks';

interface ResampleSensorModalProps {
	open: boolean;
	sensorId: string;
	sensorIds?: string[];
	onClose: () => void;
	jobsEnabled?: boolean;
}

const ResampleSensorModal: React.FC<ResampleSensorModalProps> = (
	props: ResampleSensorModalProps,
) => {
	const { jobsEnabled = false, onClose, open, sensorId, sensorIds } = props;
	const { resample, issueResampleJob } = useResampleJobs();

	const handleClickResampleModalButtonCancel = () => {
		onClose();
	};

	const handleClickResampleModalButtonConfirm = async (
		formData: ResampleFormData,
	) => {
		if (!sensorId && !sensorIds) return;
		onClose();
		const request: ResampleJobFnRequest = {
			formData,
			sensorId,
			sensorIds,
		};
		if (jobsEnabled) {
			issueResampleJob(request);
		} else {
			resample(request);
		}
	};

	return (
		<ResampleDialog
			open={open}
			jobsEnabled={jobsEnabled}
			onCancel={handleClickResampleModalButtonCancel}
			onConfirm={handleClickResampleModalButtonConfirm}
		/>
	);
};

export default ResampleSensorModal;
